
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    TOURNAMENTPROCESS_ACTION,
    ALL_TOURNAMENTPROCESS,
    ADD_TOURNAMENTPROCESS,
    FETCH_TOURNAMENTPROCESS,
    EDIT_TOURNAMENTPROCESS,
    DELETE_TOURNAMENTPROCESS,
    FETCH_TOURNAMENTPROCESSREPORT
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Tournament List Actions
 */

    export const allTournamentProcess = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: TOURNAMENTPROCESS_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettournamentmdrecord', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_TOURNAMENTPROCESS, payload: alldata });
            });
        }        
    
    }

    export const studentTournamentProcess = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:TOURNAMENTPROCESS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studenttournamentmdrecord', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_TOURNAMENTPROCESS, payload: alldata }); 
            });
        
        }
    }

    export const addTournamentProcess = (data) =>{
    
        var payload={
            "totval":"1",
            "student_1":data.target.student.value,
            "tournament":data.target.tournament.value,
            "sgdate":data.target.seldate.value,
            "country":data.target.country.value,
            "rounds":data.target.round.value,
            "drvsh_1":data.target.drvsh_1.value,
            "drvsc_1":data.target.drvsc_1.value,
            "drvnote_1":data.target.drvnote_1.value,
            "fwsh_1":data.target.fwsh_1.value,
            "fwsc_1":data.target.fwsc_1.value,
            "fwnote_1":data.target.fwnote_1.value,
            "apssh_1":data.target.apssh_1.value,
            "apssc_1":data.target.apssc_1.value,
            "apsnote_1":data.target.apsnote_1.value,
            "wpsh_1":data.target.wpsh_1.value,
            "wpsc_1":data.target.wpsc_1.value,
            "wpnote_1":data.target.wpnote_1.value,
            "bpsh_1":data.target.bpsh_1.value,
            "bpsc_1":data.target.bpsc_1.value,
            "bpnote_1":data.target.bpnote_1.value,          
            "chpsh_1":data.target.chpsh_1.value,
            "chpsc_1":data.target.chpsc_1.value,
            "chpnote_1":data.target.chpnote_1.value,
            "putsh_1":data.target.putsh_1.value,
            "putsc_1":data.target.putsc_1.value,
            "putnote_1":data.target.putnote_1.value,
            "spssh_1":data.target.spssh_1.value,
            "spssc_1":data.target.spssc_1.value,
            "spsnote_1":data.target.spsnote_1.value,
            
        }

        return (dispatch) => { 
            dispatch({ type:TOURNAMENTPROCESS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addtournamentmdrecord', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allTournamentProcess()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_TOURNAMENTPROCESS});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchTournamentProcess = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTPROCESS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchtournamentmdrecord', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_TOURNAMENTPROCESS, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editTournamentProcess = (data, id) =>{
    
        var payload={
            "id":id,
            "student":data.target.student.value,
            "tournament":data.target.tournament.value,
            "sgdate":data.target.seldate.value,
            "country":data.target.country.value,
            "rounds":data.target.round.value,
            "drvsh":data.target.drvsh_1.value,
            "drvsc":data.target.drvsc_1.value,
            "drvnote":data.target.drvnote_1.value,
            "fwsh":data.target.fwsh_1.value,
            "fwsc":data.target.fwsc_1.value,
            "fwnote":data.target.fwnote_1.value,
            "apssh":data.target.apssh_1.value,
            "apssc":data.target.apssc_1.value,
            "apsnote":data.target.apsnote_1.value,
            "wpsh":data.target.wpsh_1.value,
            "wpsc":data.target.wpsc_1.value,
            "wpnote":data.target.wpnote_1.value,
            "bpsh":data.target.bpsh_1.value,
            "bpsc":data.target.bpsc_1.value,
            "bpnote":data.target.bpnote_1.value,          
            "chpsh":data.target.chpsh_1.value,
            "chpsc":data.target.chpsc_1.value,
            "chpnote":data.target.chpnote_1.value,
            "putsh":data.target.putsh_1.value,
            "putsc":data.target.putsc_1.value,
            "putnote":data.target.putnote_1.value,
            "spssh":data.target.spssh_1.value,
            "spssc":data.target.spssc_1.value,
            "spsnote":data.target.spsnote_1.value,
            
        }
       
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTPROCESS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/edittournamentmdrecord', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allTournamentProcess()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_TOURNAMENTPROCESS});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteTournamentProcess = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTPROCESS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetournamentmdrecord', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allTournamentProcess()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_TOURNAMENTPROCESS});                    
                }
                
                
            });
        
        }
    }

    export const fetchTournamentProcessReport = (id, startdate, enddate, tournament, round) =>{
    
        var payload={
            "id":id,
            "startdate":startdate,
            "enddate":enddate,
            "tournament":tournament,
            "round":round,          
        }

        return (dispatch) => { 
            dispatch({ type:TOURNAMENTPROCESS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/reporttournamentmdrecord', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_TOURNAMENTPROCESSREPORT, payload: resdata}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }


   

